import { ReactNode } from "react";
import { FormAddon } from "../../common/form/Form";
import CollateralForm, { Props as CollateralFormProps } from "./CollateralForm";
import CollateralFormInput from "./CollateralFormInput";

type Props = Omit<CollateralFormProps, "children"> & {
  onCollateralAmountChange: (amount: string) => void;
  onRedeemableAmountChange: (amount: string) => void;
  collateralAmount: string;
  redeemableAmount: string;
  connected: boolean;
  children?: ReactNode;
};

const ToCollateralForm = ({
  onCollateralAmountChange,
  onRedeemableAmountChange,
  collateralAmount,
  redeemableAmount,
  connected,
  children,
  ...formProps
}: Props) => {
  return (
    <CollateralForm {...formProps}>
      {({ collateral, redeemable }) => {
        return (
          <>
            <CollateralFormInput
              id="redeemable-amount-input"
              name="redeemable-amount"
              label="From"
              value={redeemableAmount}
              handleChange={onRedeemableAmountChange}
              maxButtonEnabled={true}
              connected={connected}
              tokenInfo={redeemable}
            />
            {children ? (
              <FormAddon className="CollateralForm">{children}</FormAddon>
            ) : null}
            <CollateralFormInput
              id="collateral-amount-input"
              name="collateral-amount"
              label="To"
              value={collateralAmount}
              handleChange={onCollateralAmountChange}
              maxButtonEnabled={false}
              connected={connected}
              tokenInfo={collateral}
            />
          </>
        );
      }}
    </CollateralForm>
  );
};

export default ToCollateralForm;
